import { arrayWithoutSubset, setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  StorylineDigestSettingsClientLoadFulfilledAction,
  StorylineDigestSettingsClientLoadPendingAction,
  StorylineDigestSettingsClientLoadRejectedAction,
} from '../../domains/storylineDigestSettings/actions.types';
import {
  SubscribeToStorylineDigestFulfilledAction,
  SubscribeToStorylineDigestPendingAction,
  SubscribeToStorylineDigestRejectedAction,
} from '../../domains/subscribeToStorylineDigest/actions.types';
import {
  UnsubscribeFromStorylineDigestFulfilledAction,
  UnsubscribeFromStorylineDigestPendingAction,
  UnsubscribeFromStorylineDigestRejectedAction,
} from '../../domains/unsubscribeFromStorylineDigest/actions.types';

import { StorylineDigestSettingsLifecycle } from './types';

export type StorylineDigestSettingsAction =
  | StorylineDigestSettingsClientLoadPendingAction
  | StorylineDigestSettingsClientLoadRejectedAction
  | StorylineDigestSettingsClientLoadFulfilledAction
  | SubscribeToStorylineDigestFulfilledAction
  | SubscribeToStorylineDigestPendingAction
  | SubscribeToStorylineDigestRejectedAction
  | UnsubscribeFromStorylineDigestFulfilledAction
  | UnsubscribeFromStorylineDigestPendingAction
  | UnsubscribeFromStorylineDigestRejectedAction;

const initialState: StorylineDigestSettingsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<StorylineDigestSettingsLifecycle, StorylineDigestSettingsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'STORYLINE_DIGEST_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'STORYLINE_DIGEST_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'STORYLINE_DIGEST_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'STORYLINE_DIGEST.SUBSCRIBE_PENDING':
      return setPending();
    case 'STORYLINE_DIGEST.SUBSCRIBE_REJECTED':
      return setRejected(action.payload.error);
    case 'STORYLINE_DIGEST.SUBSCRIBE_FULFILLED': {
      const storylineDigestDelivery = state.fulfilled?.storylineDigestDelivery ?? [];
      if (storylineDigestDelivery.includes('EMAIL')) {
        return state;
      }

      const newStorylineDigestDelivery = [...storylineDigestDelivery, 'EMAIL'];

      return setFulfilled({ storylineDigestDelivery: newStorylineDigestDelivery });
    }
    case 'STORYLINE_DIGEST.UNSUBSCRIBE_PENDING':
      return setPending();
    case 'STORYLINE_DIGEST.UNSUBSCRIBE_REJECTED':
      return setRejected(action.payload.error);
    case 'STORYLINE_DIGEST.UNSUBSCRIBE_FULFILLED': {
      const storylineDigestDelivery = state.fulfilled?.storylineDigestDelivery ?? [];

      return setFulfilled({ storylineDigestDelivery: arrayWithoutSubset(storylineDigestDelivery, ['EMAIL']) });
    }
    default:
      return state;
  }
};

export default reducer;
